var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchMagnifyingGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 48,
    viewBox: "0 0 69 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9999 15C29.4182 15 32.9999 18.5817 32.9999 23C32.9999 27.4183 29.4182 31 24.9999 31C23.151 31 21.4504 30.3706 20.0956 29.3174L16.707 32.707C16.3164 33.0976 15.6834 33.0976 15.2929 32.707C14.9024 32.3165 14.9024 31.6835 15.2929 31.293L18.6816 27.9033C17.6288 26.5488 16.9999 24.8484 16.9999 23C16.9999 18.5817 20.5816 15 24.9999 15ZM24.9999 17C21.6862 17 18.9999 19.6863 18.9999 23C18.9999 26.3137 21.6862 29 24.9999 29C28.3136 29 30.9999 26.3137 30.9999 23C30.9999 19.6863 28.3136 17 24.9999 17Z",
    fill: "#3B81B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMagnifyingGlass);
export default __webpack_public_path__ + "static/media/searchMagnifyingGlass.0c1cb0f002fe6c272396f18edef41100.svg";
export { ForwardRef as ReactComponent };